/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./deviceTypesDetails.vue?vue&type=template&id=738db975&scoped=true&"
import script from "./deviceTypesDetails.vue?vue&type=script&lang=js&"
export * from "./deviceTypesDetails.vue?vue&type=script&lang=js&"
import style0 from "./deviceTypesDetails.vue?vue&type=style&index=0&id=738db975&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738db975",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VDialog,VForm,VIcon,VRow,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
